import { Typography } from "@mui/material";
import type { PublicPackageResponse } from "../../publicPackages/publicPackagesApi";

export function PackageHeader(props: { forPackage: PublicPackageResponse }) {
  return (
    <>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontWeight: "bold",
        }}
      >
        {props.forPackage.name}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          color: "text.secondary",
          mb: 4,
        }}
      >
        {props.forPackage.packageName}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
        Co wyróżnia tę wycieczkę
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          lineHeight: 1.7,
          mb: 4,
          whiteSpace: "pre-wrap",
        }}
      >
        {props.forPackage.description}
      </Typography>
    </>
  );
}
